import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as IconCross } from '../resources/icon_cross.svg';

const ErrorLabel = ({ content }) => {
    return (
        <div
            className="wz-lyriapay-payline-errorlabel"
            style={{ visibility: !content && 'hidden' }}
        >
            <div className="wz-lyriapay-payline-errorlabel-icon">
                <IconCross />
            </div>
            <div className="wz-lyriapay-payline-errorlabel-content">
                {content}
            </div>
        </div>
    );
};

ErrorLabel.propTypes = {
    content: PropTypes.node
};

export default ErrorLabel;
